class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    //reloadswiper();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    reloadSlickSlider();
    // reloadswiper();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// function reloadSlickSlider() {
//   if (window.jQuery && typeof jQuery.fn.slick === 'function') {
//     jQuery('.complemantory-product-list').not('.slick-initialized').slick({
//       slidesToShow: 1.32,
//       slidesToScroll: 1,
//       autoplay: false,
//       infinite: false,
//       autoplaySpeed: 2000,
//       prevArrow: '',
//       nextArrow: ''
//     });
//   } else {
//     console.error('jQuery or Slick is not loaded.');
//   }
// }

// // Optional: Call it on DOMContentLoaded
// document.addEventListener('DOMContentLoaded', reloadSlickSlider);


/* ===========================
   Cart guards ligeros (v2)
   - El regalo y el bundle 2+1 los gestiona la logica global de theme.liquid
   - Interceptor minimo: tras una mutacion de carrito emite un unico cart:updated
   =========================== */
(() => {
  const GIFT_ID = 52841202614602;

  function setupQuantityValidation() {
    document.addEventListener("keydown", (e) => {
      const input = e.target.closest("input.quantity__input");
      if (!input) return;
      if (e.key === "-") e.preventDefault();
    });

    document.addEventListener("blur", (e) => {
      const input = e.target.closest("input.quantity__input");
      if (!input) return;
      const val = parseInt(input.value, 10);
      if (isNaN(val) || val <= 0) {
        input.value = 1;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }, true);
  }

  function disableEnterWhenCartOpen() {
    document.addEventListener("keydown", (e) => {
      const drawer = document.querySelector("cart-drawer, #CartDrawer");
      const isOpen = drawer?.classList.contains("active") || drawer?.hasAttribute("open");
      const input = e.target.closest("input.quantity__input");
      if (isOpen && e.key === "Enter" && input) e.preventDefault();
    });
  }

  // Bloquear checkout si solo queda el regalo en el carrito
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#CartDrawer-Checkout");
    if (!btn) return;
    const c = window.__edLastCart;
    if (c && c.items.length > 0 && c.items.every(i => i.id === GIFT_ID)) {
      e.preventDefault();
      alert("Añade un producto para finalizar la compra.");
    }
  });

  // Interceptor minimo y no reentrante
  const origFetch = window.fetch;
  let notifyTimer = null;
  window.fetch = function (...args) {
    const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
    const p = origFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)/.test(url) && !url.includes("ed_internal=1")) {
      p.then(() => {
        clearTimeout(notifyTimer);
        notifyTimer = setTimeout(() => document.dispatchEvent(new CustomEvent("cart:updated")), 120);
      }).catch(() => {});
    }
    return p;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { setupQuantityValidation(); disableEnterWhenCartOpen(); });
  } else {
    setupQuantityValidation();
    disableEnterWhenCartOpen();
  }
})();
